<template>
    <router-view></router-view>
</template>
<script setup>
import { nextTick } from 'vue';
import cookie from '@/commons/cookie.js';
import { useRoute, useRouter } from 'vue-router';
import { userLevel } from '@/commons/utils';
const currentUserLevel = userLevel();
const route = useRoute();
const router = useRouter();
if (route.name === 'userList' && currentUserLevel !== 0) {
    router.push({
        path: '/admin/task/list'
    });
}
</script>
